import get from "lodash/get"

// Позволяет забрать из стора список по полей
export const selectFields = state => {
  return get(state, `fields`)
}
